/**
 * @file        src/components/Pager.jsx
 * @description Numeric pager for list views.
 * @author      Kinetika Labs
 * @created     2026-06-22
 * @changelog
 *   - 2026-06-22 Claude — Initial.
 */
export default function Pager({ page, pageSize, total, onPage }) {
  const pages = Math.max(1, Math.ceil((total || 0) / pageSize));
  if (pages <= 1) return null;
  const start = Math.max(1, page - 2);
  const end = Math.min(pages, start + 4);
  const window = [];
  for (let i = start; i <= end; i++) window.push(i);
  return (
    <div className="pager">
      <button className="pg" disabled={page <= 1} onClick={() => onPage(page - 1)}>← Prev</button>
      {window.map((p) => (
        <button key={p} className={`pg ${p === page ? 'active' : ''}`} onClick={() => onPage(p)}>{p}</button>
      ))}
      <button className="pg" disabled={page >= pages} onClick={() => onPage(page + 1)}>Next →</button>
    </div>
  );
}
